import { Routes as BrowserRoutes, Route, useNavigate } from "react-router";
import { Box, Divider, Flex, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { Container, Icon, Pressable, Scope } from "components";
import Identity from "./identity";
import BlackBNF from "./black-bnf";
import BonusMentor from "./bonus-mentor";
import Orders from "./orders";
import Sessions from "./sessions";

export default function Tools(){

    return(
        <BrowserRoutes>
        
            {/* Home */}
            <Route path="/" element={<Home />} />
    
            {/* Home */}
            <Route path="/identity" element={<Identity />} />

            {/* Black BNF */}
            <Route path="/black-bnf" element={<BlackBNF />} />

            {/* Bônus Mentor */}
            <Route path="/bonus-mentor" element={<BonusMentor />} />

            {/* Relatórios de Pedidos */}
            <Route path="/orders" element={<Orders />} />

            {/*Gerenciamento de Sessões*/}
            <Route path="/sessions" element={<Sessions />} />
    
        </BrowserRoutes>
    )
    
}

const Home = () => {

    const navigate = useNavigate()

    return(
    <Container>

        <Flex alignItems="center" justifyContent="center" direction="column">
            <Icon name="tools" fontSize="3rem" color="orange" />
            <Heading children="Caixa de ferramentas" />
            <Text color="GrayText" children="Ferramentas implantadas conforme necessidade da empresa" />
        </Flex>

        <Divider my={6} />

        <Grid templateColumns="1fr 1fr 1fr 1fr" gap={6}>
            <Scope role="tools_identity">
                <GridItem>
                    <Pressable onClick={() => navigate('/tools/identity')}>
                        <Box p={4} borderRadius={8} bgGradient="linear-gradient(45deg, #85FFBD 0%, #FFFB7D 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                            <Icon name="identity" fontSize="2rem" color="#444" />
                            <Text color="#333" fontWeight="bold" children="Identidade" />
                            <Text color="#444" fontSize="xs" children="Ferramenta de validação de identidade de consultores." />
                        </Box>
                    </Pressable>
                </GridItem>
            </Scope>
            
            <Scope role="tools_black_bnf">
                <GridItem>
                    <Pressable onClick={() => navigate('/tools/black-bnf')}>
                        <Box p={4} borderRadius={8} bgGradient="linear-gradient(140deg, rgba(0,0,0,1) 0%, rgba(40,46,47,1) 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                            <Icon name="" fontSize="2rem" color="#FFF" />
                            <Text color="#FFF" fontWeight="bold" children="Black BNF" />
                            <Text color="GrayText" fontSize="xs" children="Consultores que participam do programa Black BNF." />
                        </Box>
                    </Pressable>
                </GridItem>
            </Scope>

            <Scope role="tools_mentor">
                <GridItem>
                    <Pressable onClick={() => navigate('/tools/bonus-mentor')}>
                        <Box p={4} borderRadius={8} bgGradient="linear-gradient(62deg, #FBAB7E 0%, #F7CE68 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                            <Icon name="diamond" fontSize="2rem" color="#444" />
                            <Text color="#333" fontWeight="bold" children="Bônus Mentor" />
                            <Text color="#444" fontSize="xs" children="Relatório de líderes que fizeram 1 ou mais diamantes diretos." />
                        </Box>
                    </Pressable>
                </GridItem>
            </Scope>

            <Scope role="tools_orders_reports">
                <GridItem>
                    <Pressable onClick={() => navigate('/tools/orders')}>
                        <Box p={4} borderRadius={8} bgGradient="linear-gradient(62deg, #00d2ff 0%, #3a47d5 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                            <Icon name="orders" fontSize="2rem" color="#FFF" />
                            <Text color="#FFF" fontWeight="bold" children="Relatórios de pedidos" />
                            <Text color="#FFF" fontSize="xs" children="Várias opções de relatórios sobre pedidos do sistema" />
                        </Box>
                    </Pressable>
                </GridItem>
            </Scope>

            <Scope role="tools_files">
                <GridItem>
                    <Pressable isDisabled>
                        <Box p={4} borderRadius={8} bgGradient="linear-gradient( 104.1deg,  rgba(0,61,100,1) 13.6%, rgba(47,127,164,1) 49.4%, rgba(30,198,198,1) 93.3% )" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                            <Icon name="search" fontSize="2rem" color="#FFF" />
                            <Text color="#FFF" fontWeight="bold" children="Drive" />
                            <Text color="#FFF" fontSize="xs" children="Busca e gerenciamento de arquivos do sistema." />
                        </Box>
                    </Pressable>
                </GridItem>
            </Scope>
            
            <Scope role="tools_expired_consultants">
                <GridItem>
                    <Pressable isDisabled>
                        <Box p={4} borderRadius={8} bgGradient="linear-gradient(to top, #a8edea 0%, #fed6e3 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                            <Icon name="user" fontSize="2rem" color="#444" />
                            <Text color="#444" fontWeight="bold" children="Expirados" />
                            <Text color="#555" fontSize="xs" children="Visualização de cadastros expirados de consultores" />
                        </Box>
                    </Pressable>
                </GridItem>
            </Scope>

            {/*Sessões Ativas*/}
            <Scope role="tools_sessions">
                <GridItem>
                    <Pressable >
                        <Pressable onClick={() => navigate('/tools/sessions')}>
                            <Box p={4} borderRadius={8} bgGradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                                <Icon name="plug" fontSize="2rem" color="#FFF" />
                                <Text color="#FFF" fontWeight="bold" children="Sessões Ativas" />
                                <Text color="rgba(255,255,255,0.8)" fontSize="xs" children="Gerencie usuários logados, IPs e tempos de conexão." />
                            </Box>
                        </Pressable>
                    </Pressable>
                </GridItem>
            </Scope>
        </Grid>
    </Container>
    )
}

const Tool = ({ title, description, icon, bgGradient, ...props }) => {
    return(
    <Pressable {...props}>
        <Box p={4} borderRadius={8} bgGradient={bgGradient}>
            <Icon name={icon} fontSize="2rem" />
            <Text fontWeight="bold" children={title} />
            <Text color="GrayText" fontSize="xs" children={description} />
        </Box>
    </Pressable>
    )
}